<template>
  <b-carousel-slide>
    <img :src="renderImage" :class="isClickable ? 'pointer' : ''" :alt="popup.title" @click="moveToUrl()"/>
  </b-carousel-slide>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'PopupItem',
  props: {
    popup: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  computed: {
    renderImage() {
      if (this.width < 600) {
        return this.popup.mobileImageUrl;
      }
      return this.popup.pcImageUrl;
    },
    isClickable() {
      return this.popup.linkTargetType.code !== 'NONE';
    },
  },
  methods: {
    moveToUrl() {
      common.moveToUrlOfTargetType(this, this.popup.linkTargetType.code, this.popup.popupLinkUrl);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
